export const sendBingSpreadedConversion = (email?: string) => {
  if (typeof window === 'undefined' || email === undefined) return;

  window.uetq = window.uetq || [];
  window.uetq.push('set', { pid: { em: email } });
};
